import { designStore } from './store';

export const {
  hideSaveVpcSheet,
  hideCantOpenDesignModal,
  hideSaveDesignToProfileSheet,
  hideSaveAsDesignToProfileSheet,
  hideShareDesignCard,
  hideOpenDesignSheet,
  resetDesignState,
  setLoadVpcSheetVisible,
  setLoadVpcSheetVisibleOnExit,
  setSaveVpcSheetOpenedFromPrint,
  setOpenDesignSheetVisibleOnExit,
  showSaveVpcSheet,
  showSaveDesignToProfileSheet,
  showSaveAsDesignToProfileSheet,
  showOpenDesignSheet,
  showShareDesignCard,
  showCantOpenDesignModal,
  setOpenDesignActiveTab
} = designStore.getInitialState().actions;
